import { useEffect, useRef } from 'react';
import {
	HOME_PAGE_DEFAULT_OPEN_GIC,
	UC_ATLASSIAN_HOME_CREATE_ISSUE,
} from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/constants.tsx';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';

const OPEN_GLOBAL_ISSUE_CREATE = 'createissue';
const GIC_TRIGGER_SOURCE = 'gicTriggerSource';
const UNIVERSAL_CREATE_HOME_SOURCE_VALUE = 'ucAtlassianHomeCreateIssue';

export const IssueCreateHomePageTrigger = () => {
	const [, { openIssueCreateModal }] = useTriggerIssueCreateModal();
	const createIssueRef = useRef(true);
	const [openGlobalIssueCreate, _setopenGlobalIssueCreate] =
		useQueryParam(OPEN_GLOBAL_ISSUE_CREATE);
	const [gicTriggerSource] = useQueryParam(GIC_TRIGGER_SOURCE);

	useEffect(() => {
		if (createIssueRef.current && openGlobalIssueCreate === 'true') {
			const isFromUniversalCreateHome = gicTriggerSource === UNIVERSAL_CREATE_HOME_SOURCE_VALUE;
			const triggerPointKey = isFromUniversalCreateHome
				? UC_ATLASSIAN_HOME_CREATE_ISSUE
				: HOME_PAGE_DEFAULT_OPEN_GIC;

			openIssueCreateModal({
				triggerPointKey,
			});
		}
		createIssueRef.current = false;
	}, [openIssueCreateModal, openGlobalIssueCreate, gicTriggerSource]);
	return null;
};

export default IssueCreateHomePageTrigger;
